import { NgModule } from '@angular/core';
import { StakingData } from './services/staking-data';
import { StakingStatisticsService } from './services/staking-stats.service';

@NgModule({
  providers: [StakingData, StakingStatisticsService],
})
export class StakingServicesModule {}
